import { render, staticRenderFns } from "./ConfirmPopup.vue?vue&type=template&id=0646e4a3&"
import script from "./ConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./ConfirmPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports